import * as ws_base from '../ws/ws_base'


const DOMINIO = "imagem_item";



export async function buscarImagemItem(id_imagem){

	return await ws_base.get(DOMINIO, "obter", {"id": id_imagem});
}


export async function buscarImagensItens(id_item){

	return await ws_base.post(DOMINIO, "obter", {"id_item": id_item});
}


export async function salvarImagemItem(id_item, imagem){

	return await ws_base.upload(DOMINIO, "salvar", {"id_item": id_item}, imagem);
}


export async function removerImagemItem(id_imagem){

	return await ws_base.get(DOMINIO, "remover", {"id": id_imagem});
}
